import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/ToastProvider';
import App from './App.tsx';
import './i18n';
import './index.css';
import { initSentry } from './lib/sentry';
import * as Sentry from '@sentry/react';

// Initialize Sentry
initSentry();

// Create a Sentry error boundary
const SentryErrorBoundary = Sentry.withErrorBoundary(App, {
  fallback: <div>An error has occurred</div>,
  showDialog: true,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback="Loading...">
      <AuthProvider>
        <ToastProvider>
          <SentryErrorBoundary />
        </ToastProvider>
      </AuthProvider>
    </Suspense>
  </StrictMode>
);